import React from 'react';
import { TableHead } from './table';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

/**
 * SortableTableHead — drop-in replacement for <TableHead> with sort affordance.
 *
 * Props:
 *   sortKey   — current active sort column key
 *   sortDir   — 'asc' | 'desc' | null
 *   columnKey — this column's key
 *   onSort    — (key) => void
 *   children  — header label
 *   ...rest   — passed through to TableHead (className, etc.)
 */
export function SortableTableHead({ sortKey, sortDir, columnKey, onSort, children, className = '', ...rest }) {
  const isActive = sortKey === columnKey;

  return (
    <TableHead
      className={`select-none cursor-pointer group ${className}`}
      onClick={() => onSort(columnKey)}
      {...rest}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        {isActive ? (
          sortDir === 'asc'
            ? <ArrowUp className="w-3.5 h-3.5 text-foreground shrink-0" />
            : <ArrowDown className="w-3.5 h-3.5 text-foreground shrink-0" />
        ) : (
          <ArrowUpDown className="w-3.5 h-3.5 text-muted-foreground/0 group-hover:text-muted-foreground/50 shrink-0 transition-colors" />
        )}
      </span>
    </TableHead>
  );
}
